import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { KEY_TOKEN, KEY_USER } from "utils/constants";
import { useAuth } from "../contexts/authProvider";
import Icon from "./AppIcon";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  // Estado derivado: não precisa de useState/re-render extra — o valor já é
  // função direta de `user` e `loading`.
  const shouldRender = !loading && !!user;

  useEffect(() => {
    // Só age quando a sessão terminou de carregar e não há usuário.
    if (loading || user) return;

    localStorage.removeItem(KEY_USER);
    localStorage.removeItem(KEY_TOKEN);
    navigate("/user-login", { replace: true });
  }, [user, loading, navigate]);

  // Mostra loading enquanto está carregando ou verificando autenticação
  if (loading || !shouldRender) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Icon
            name="Loader"
            size={48}
            className="text-muted-foreground mx-auto mb-4 animate-spin"
          />
          <p className="text-muted-foreground">
            {loading ? "Verificando autenticação..." : "Redirecionando..."}
          </p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
